import styles from './FloorPlanSkeleton.module.css';

interface IFloorPlanSkeletonProps {
  label: string;
}

export function FloorPlanSkeleton({ label }: IFloorPlanSkeletonProps) {
  return (
    <div className={styles.skeleton} role="status">
      <svg className={styles.plan} viewBox="0 0 240 160" aria-hidden="true">
        <rect className={styles.room} x="97" y="97" width="134" height="54" />
        <path className={styles.wall} pathLength={1} d="M8 8 H232 V152 H8 Z" />
        <path className={styles.wall} pathLength={1} d="M96 8 V64" />
        <path className={styles.wall} pathLength={1} d="M96 84 V152" />
        <path className={styles.wall} pathLength={1} d="M96 96 H160" />
        <path className={styles.wall} pathLength={1} d="M180 96 H232" />
        <path className={styles.wall} pathLength={1} d="M8 64 H44" />
        <circle className={styles.dot} cx="164" cy="124" r="5" />
      </svg>
      <span className={styles.label}>{label}</span>
    </div>
  );
}
